import type { NavParams, SheetKey } from '@shared-core/navigation/routes'
import { createContext, useContext } from 'react'

export type SheetContextValue = {
  id: string
  params: unknown
}

export const SheetContext = createContext<SheetContextValue | null>(null)

// Параметры текущего шита. Аналог useRoute().params в react-navigation.
export function useSheetParams<K extends SheetKey>(): NavParams[K] {
  const ctx = useContext(SheetContext)

  if (!ctx) {
    throw new Error('useSheetParams должен использоваться внутри компонента шита')
  }

  return ctx.params as NavParams[K]
}
